import { useEffect, useState } from "react";

/**
 * Live countdown to a target ISO/Date. Returns {d,h,m,s,total,done}.
 * Ticks every second; cleans up on unmount.
 */
export default function useCountdown(target) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const end = target ? new Date(target).getTime() : now;
  const total = Math.max(0, end - now);
  const d = Math.floor(total / 86400000);
  const h = Math.floor((total % 86400000) / 3600000);
  const m = Math.floor((total % 3600000) / 60000);
  const s = Math.floor((total % 60000) / 1000);
  return { d, h, m, s, total, done: total === 0 };
}

/** True when target is more than 1 year away — treat as "rolling / year-round". */
export function isRolling(target) {
  if (!target) return true;
  const days = (new Date(target).getTime() - Date.now()) / 86400000;
  return days > 365;
}
